import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Login from "containers/Login/Login";
import PageNotFound from "components/PageNotFound";
import routes from "constants/routes";
import HomePage from "containers/HomePage/HomePage";
import PackageDetails from "containers/PackageDetails/PackageDetails";
import CreatePackage from "containers/CreatePackage/CreatePackage";
import CreateProductOfferings from "containers/CreateProductOfferings/CreateProductOfferings";
import CreatePackageVersion from "containers/CreatePackageVersion/CreatePackageVersion";
import UploadFeatureOfferings from "containers/UploadFeatureOfferings/UploadFeatureOfferings";
import UploadPackageSchedule from "containers/UploadPackageSchedule/UploadPackageSchedule";
import UpdatePackageSchedule from "containers/UpdatePackageSchedule/UpdatePackageSchedule";
import AuthenticatedRoutes from "hocs/AuthenticatedRoutes";
import UploadOrUpdatePackagePaymentHead from "containers/UploadOrUpdatePackagePaymentHead/UploadOrUpdatePackagePaymentHead";

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Navigate to={routes.login.root} />} />

    <Route path={routes.login.root} element={<Login />} />
    <Route element={<AuthenticatedRoutes />}>
      <Route path={routes.homePage.homePage} element={<HomePage />} />
      <Route
        path={routes.packageDetails.packageDetails}
        element={<PackageDetails />}
      />
      <Route
        path={routes.createPackage.createPackage}
        element={<CreatePackage />}
      />
      <Route
        path={routes.createProductOfferings.createProductOfferings}
        element={<CreateProductOfferings />}
      />
      <Route
        path={routes.createPackageVersion.createPackageVersion}
        element={<CreatePackageVersion />}
      />
      <Route
        path={routes.uploadFeatureOfferings.uploadFeatureOfferings}
        element={<UploadFeatureOfferings />}
      />
      <Route
        path={routes.uploadPackageSchedule.uploadPackageSchedule}
        element={<UploadPackageSchedule />}
      />
      <Route
        path={routes.updatePackageSchedule.updatePackageSchedule}
        element={<UpdatePackageSchedule />}
      />
      <Route 
        path={routes.uploadOrUpdatePackagePaymentHead.uploadOrUpdatePackagePaymentHead}
        element={<UploadOrUpdatePackagePaymentHead />}
      />
      <Route path="*" element={<PageNotFound />} />
    </Route>
  </Routes>
);

export default AppRoutes;
